module.exports = "/_next/static/images/e33e0b1b348dcca57e657114a2e7db30-cajitas-left-desktop.jpg";